var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _circle, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInviteNewUser = function SvgInviteNewUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 114,
    viewBox: "0 0 191 114",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 8H180V95H77V8Z",
    fill: "#CAFFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29H105V108H14V29Z",
    fill: "#FFECB5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458929,
    d: "M86.0467 29H6.95327C3.11309 29 0 31.4624 0 34.5C0 37.5376 3.11309 40 6.95327 40H86.0467C89.8869 40 93 37.5376 93 34.5C93 31.4624 89.8869 29 86.0467 29Z",
    fill: "#B8AAC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458929,
    d: "M164.047 40H84.9533C81.1131 40 78 42.4624 78 45.5C78 48.5376 81.1131 51 84.9533 51H164.047C167.887 51 171 48.5376 171 45.5C171 42.4624 167.887 40 164.047 40Z",
    fill: "#B8AAC5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458929,
    d: "M184.047 62H104.953C101.113 62 98 64.4624 98 67.5C98 70.5376 101.113 73 104.953 73H184.047C187.887 73 191 70.5376 191 67.5C191 64.4624 187.887 62 184.047 62Z",
    fill: "#B8AAC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458929,
    d: "M118.047 79H38.9533C35.1131 79 32 81.4624 32 84.5C32 87.5376 35.1131 90 38.9533 90H118.047C121.887 90 125 87.5376 125 84.5C125 81.4624 121.887 79 118.047 79Z",
    fill: "#B8AAC5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.5,
    cy: 57,
    rx: 56.5,
    ry: 57,
    fill: "#6DE1BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.128 40.2949C108.128 46.5409 103.11 51.5897 96.9381 51.5897C90.7661 51.5897 85.748 46.5409 85.748 40.2949C85.748 34.0488 90.7661 29 96.9381 29C103.11 29 108.128 34.0488 108.128 40.2949Z",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4102 70.6325C79.4102 64.1634 82.8389 58.5046 87.9614 55.4022C88.0875 55.487 88.2334 55.5839 88.3966 55.6905C88.993 56.0798 89.8247 56.6001 90.7636 57.1218C91.6999 57.6421 92.7591 58.1728 93.8085 58.5758C94.8419 58.9727 95.9425 59.2762 96.939 59.2762C97.9302 59.2762 99.0313 58.9686 100.066 58.5682C101.117 58.1612 102.182 57.6252 103.126 57.0999C104.072 56.573 104.912 56.0476 105.514 55.6544C105.683 55.5442 105.834 55.4441 105.964 55.357C111.128 58.4495 114.59 64.1318 114.59 70.6325C114.59 77.8483 112.573 81.0995 109.663 82.6988C108.147 83.5323 106.293 83.9738 104.133 84.1983C101.97 84.423 99.5795 84.4241 97 84.4241C94.4205 84.4241 92.03 84.423 89.8673 84.1983C87.7068 83.9738 85.8532 83.5323 84.3366 82.6988C81.4268 81.0995 79.4102 77.8483 79.4102 70.6325Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 76,
    r: 15,
    fill: "#6DE1BF",
    stroke: "white",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109,
    y1: 70,
    x2: 109,
    y2: 82,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 76,
    x2: 103,
    y2: 76,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteNewUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invite-new-user.a6f8de41.svg";
export { ForwardRef as ReactComponent };